// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import DropboxOutlinedSvg from "@fishx/icons-svg/es/asn/DropboxOutlined";
import FishxIcon from '../components/FishxIcon';

var DropboxOutlined = function DropboxOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: DropboxOutlinedSvg
  }));
};

DropboxOutlined.displayName = 'DropboxOutlined';
export default React.forwardRef(DropboxOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/DropboxOutlined.js
// module id = 2479
// module chunks = 0